import { render } from "./FooterModals.vue?vue&type=template&id=c963ff12&lang=pug"
import script from "./FooterModals.vue?vue&type=script&lang=js"
export * from "./FooterModals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__